import dotProp from 'dot-prop-immutable'
import { connect } from 'react-redux'
import { changeBorder } from '../../actions/project/border'
import { toggleFramesModal } from '../../actions/sidebar'
import CollectionFrames from '../../components/CollectionFrames'
import findFrame from './findFrame'

const mapStateToProps = state => ({
  frames: findFrame(
    dotProp.get(state, 'frames.frames', []),
    dotProp.get(state, 'frames.current', { width: 0, height: 0 })
  ),
  isLoading: dotProp.get(state, 'frames.isLoading', false),
  errMessage: dotProp.get(state, 'frames.errMessage', ''),
  perMeter: dotProp.get(state, 'project.background.perMeter', 300),
})

const mapDispatchToProps = dispatch => ({
  onClick: (borderType, borderWidth, label) => dispatch(changeBorder(borderType, borderWidth, '#000000', label)),
  onZoom: src => dispatch(toggleFramesModal(src)),
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CollectionFrames)



// WEBPACK FOOTER //
// ./src/containers/CollectionFrames/index.js